import React from 'react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { FAMILIAS } from './salesData';
import { FAMILIA_STYLES } from './familiaStyles';

/**
 * Las 4 P: panes, pizzas, pastas y postres. La sección apetitosa de la página —
 * foto grande por familia y el color de cada una, como en el mockup.
 */
export function FlavorsSection() {
  return <section id="recetas" className="w-full border-b border-line bg-ink" data-id="element-76" data-mp="3j22pd3nkw5ij">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-77" data-mp="3j45ellgwpum7">
        <div className="max-w-2xl" data-id="element-78" data-mp="3e4amxfpb5103">
          <SectionTag data-id="element-79" data-mp="3e5c13t1me3m1">Las 4P</SectionTag>
          <h2 className="mt-4 font-condensed text-[2.1rem] uppercase leading-[0.95] text-bone sm:text-5xl" data-id="element-80" data-mp="39bhi6rtu9so0">
            Las 4P para <span className="text-glow-gold" data-id="element-81" data-mp="34ceqe92vdixz">no aburrirte en keto</span>
          </h2>
          <p className="mt-4 font-display text-[0.95rem] uppercase leading-snug tracking-[0.01em] text-ash sm:text-[1.05rem]" data-id="element-82" data-mp="5o7rc8bgz2s4">
            Panes, pizzas, pastas y postres. Todo sin harinas ni azúcares.
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-83" data-mp="zomin5aftikx">
          {FAMILIAS.map(familia => {
          const style = FAMILIA_STYLES[familia.familia];
          return <article key={familia.familia} className={`group flex h-full flex-col overflow-hidden rounded-2xl border bg-carbon-soft ${style.border}`} style={{
            boxShadow: `0 30px 70px -45px ${style.hex}80`
          }} data-id="element-84" data-mp="px8egk7jjulg">
                <div className="relative overflow-hidden" data-id="element-85" data-mp="kz6vdza47v9z">
                  <img src={familia.imagen} alt={`${familia.nombre} keto`} loading="lazy" decoding="async" className="h-48 w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03] sm:h-56" data-id="element-86" data-mp="kwlrz5u657a4" />
                  <div className="absolute inset-0 bg-gradient-to-t from-carbon-soft via-transparent" aria-hidden data-id="element-87" data-mp="26cjglqk6ojxp" />
                  <h3 className="absolute bottom-3 left-5 font-condensed text-4xl uppercase leading-none sm:text-5xl" style={{
                color: style.hex,
                textShadow: '0 4px 24px rgba(0,0,0,0.85)'
              }} data-id="element-88" data-mp="24vvuozbsoliq">
                    {familia.nombre}
                  </h3>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-89" data-mp="1pzy4dxojybef">
                  <p className="font-display text-[0.98rem] leading-snug text-bone" data-id="element-90" data-mp="2nkkc3bb2k8pr">
                    {familia.claim}
                  </p>
                  <p className="mt-3 text-[0.92rem] leading-relaxed text-ash" data-id="element-91" data-mp="2iov88vs0o5nn">
                    {familia.descripcion}
                  </p>
                  <ul className="mt-auto flex flex-wrap gap-2 pt-5" data-id="element-92" data-mp="28xhd1073ls0b">
                    {familia.ejemplos.map(ejemplo => <li key={ejemplo} className={`rounded-full px-2.5 py-1 text-[0.72rem] text-bone/80 ${style.tint}`} data-id="element-93" data-mp="36do6iyw42plf">
                        {ejemplo}
                      </li>)}
                  </ul>
                </div>
              </article>;
        })}
        </div>

        <div className="mt-10 flex flex-col items-start gap-3" data-id="element-94" data-mp="3itnvlecifhvd">
          <CTAButton data-id="element-95" data-mp="3ntio1mbxofij" />
          <p className="text-[0.78rem] text-ash" data-id="element-96" data-mp="3nu25l1xo91w1">
            500 recetas listas para elegir qué comer hoy.
          </p>
        </div>
      </div>
    </section>;
}